import {AbstractControl, ValidatorFn} from '@angular/forms';

export const taxpayersAccountNumberValidator: ValidatorFn = (control: AbstractControl): {invalidMessage: string} => {
  if ((<string>control.value) === '') return null;

  const taxpayersAccountNumberRegex: RegExp = /^[A-Z]{2} ?\d{9}$/;

  try {
    if ((<string>control.value).match(taxpayersAccountNumberRegex)) {
      return null;
    }
  } catch {
    // fall through to invalid
  }

  return {invalidMessage: 'Die Steuernummer muss mit zwei Großbuchstaben beginnen, gefolgt von einem optionalen ' +
      'Leerzeichen und genau 9 Ziffern (z.\u202fB. DE\u00a0123456789).'};
};
